import { ORG_NAME } from "app/appConfig";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import { getDateTime, getImgLogo, getImgLogoTreamentPrint, getPrintPatientCode, getSystemConfig, TextView , hideMiddleDigits } from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo } from "react";

const RegisterCardPrintContent = (props) => {
    const {
        componentRef,
        patient

    } = props;

    const {
        printContent,
        handleSetPrintContent
    } = useStore().patientManagementStore.registerCardStore;
    let rowIndex = 1 
    let rowIndexs = 1 
    // console.log("printContent", printContent);


    return (
        <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
            <div className="form-container">
                <div className="logo-header">
                    <div className="logo">
                         {getImgLogoTreamentPrint({ height: "100px", width: "150px" })}
                    </div>
                    <div className="clinic-infos">
                         <strong> {getSystemConfig("ORG_NAME")}</strong><br />
                        <strong>Hồ sơ thông tin khách hàng</strong>
                    </div>
                    <div className="clinic-infos">
                    </div>
                </div>
                <h3>I. THÔNG TIN CÁ NHÂN</h3>
                <table className="info-table">
                    <tbody>
                        <tr>
                            <td className="dotted-label">
                                <span>{rowIndex++}. Tên khách hàng:</span>
                                <span className="dots">{patient?.patientInfo?.displayName || ''}</span>
                            </td>
                            <td className="dotted-label">
                                <span>Mã khách hàng:</span>
                                <span className="dots">{getPrintPatientCode(patient, patient?.patientInfo)}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="dotted-label">
                                <span>{rowIndex++}. Số điện thoại:</span>
                                <span className="dots">{hideMiddleDigits(patient?.patientInfo?.phoneNumber) || ''}</span>
                            </td>
                            <td className="dotted-label">
                                <span>Nghề nghiệp:</span>
                                <span className="dots">{patient?.patientInfo?.profession?.name || ''}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="dotted-label">
                                <span>{rowIndex++}. Ngày sinh:</span>
                                <span className="dots">{patient?.patientInfo?.birthDate
                                    ? new Date(patient.patientInfo.birthDate).toLocaleDateString('vi-VN')
                                    : ''}
                                </span>
                            </td>
                            <td className="dotted-label">
                                <span>Giới tính:</span>
                                <span className="dots">{patient?.patientInfo?.gender === 'F' ? 'Nữ' : 'Nam'}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="dotted-label full-width" colSpan="2">
                                <span>{rowIndex++}. Nguồn:</span>
                                <span className="dots">{patient?.patientInfo?.currentPatientSource?.name || ''}</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="dotted-label full-width" colSpan="2">
                                <span>{rowIndex++}. Địa chỉ:</span>
                                <span className="dots">
                                    {[
                                        patient?.patientInfo?.currentWard?.name,
                                        patient?.patientInfo?.currentDistrict?.name,
                                        patient?.patientInfo?.currentProvince?.name
                                    ]
                                        .filter(Boolean)
                                        .join(', ')}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h3>II. THÔNG TIN CHUNG</h3>
                <table  className="info-table">
                    <tbody>
                        <tr>
                            <td className="dotted-label">
                                <span>{rowIndexs++}. Chi nhánh:</span>
                                <span className="dots"></span>
                            </td>
                            <td className="dotted-label">
                                <span>Hotline:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>
                        <tr>
                            <td className="dotted-label full-width" colSpan="2">
                                <span>{rowIndexs++}. Hạng khách hàng:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>
                        <tr>
                            <td className="dotted-label">
                                <span>{rowIndexs++}. Dịch vụ tư vấn gần đây:</span>
                                <span className="dots"></span>
                            </td>
                            <td className="dotted-label">
                                <span>Nhân viên tư vấn:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h3>III. THÔNG TIN THẺ</h3>
                <div className="table-responsive">
                    <table className="service-table">
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>TÊN DỊCH VỤ</th>
                                <th>SL</th>
                                <th>ĐƠN GIÁ (VND)</th>
                                <th>THÀNH TIỀN (CẦN THU)</th>
                                <th>TG ĐĂNG KÝ</th>
                            </tr>
                        </thead>

                        {printContent?.map((item, index) => (
                            <>
                                <tbody key={index}>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{item?.clientCard?.name || "-"}</td>
                                        <td>{item?.quantity || 1}</td>
                                        <td>{item?.price?.toLocaleString() || "0"}</td>
                                        {/* <td>{(item?.price * item?.quantity)?.toLocaleString() || "0"}</td> */}
                                        <td>{item?.amountActuallyPaid?.toLocaleString() || "0"}</td>
                                        <td>{getDateTime(item?.startDate)}</td>
                                    </tr>
                                </tbody>
                            </>
                        ))}

                        <tfoot>
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                                    TỔNG TIỀN:
                                </td>
                                <td style={{ fontWeight: "bold" }}>
                                    {printContent?.reduce((acc, item) => acc + (item?.amountActuallyPaid || 0), 0).toLocaleString()}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </PrintCommon>
    );
};

export default memo(observer(RegisterCardPrintContent));
